import {appRouter} from '@netx/core-next/instance/router';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {isBrandPortal, getCurrentPortalProp} from '@netx/core-cms-next/utils';
import {createVisualRule} from '@netx/core-search-rules/rules/visual/visualRule';
import {VisualType} from '@netx/core-search-rules/rules/visual/constants';
import {convertToRules} from '@netx/core-search-rules/utils/convertToRules';
import {
	createCategoryIdRule,
	CategoryType,
	type SearchRule,
} from '@netx/core-search-rules/rules';
import {SEARCH_VISUAL_EVENT, SEARCH_VISUAL_BASE_EVENT} from './actions';
import routes from './routes';

dispatcher.once(`${SEARCH_VISUAL_BASE_EVENT}:init`, () => {
	appRouter
		.on(`route:${SEARCH_VISUAL_EVENT.ASSET}`, (assetId: string, page = '1') => {
			dispatcher.trigger(
				SEARCH_VISUAL_EVENT.ASSET,
				parseInt(assetId),
				parseInt(page) || 1,
			);
		})
		.on(`route:${SEARCH_VISUAL_EVENT.COLOR}`, (color: string, page = '1') => {
			dispatcher.trigger(SEARCH_VISUAL_EVENT.COLOR, color, parseInt(page) || 1);
		});

	dispatcher.on(SEARCH_VISUAL_EVENT.ASSET, (assetId: number, page = '1') => {
		const ruleItems: SearchRule[] = [
			createVisualRule({
				type: VisualType.ASSET,
				assetId,
			}),
		];

		if (isBrandPortal()) {
			const searchId = getCurrentPortalProp('category');
			if (searchId && searchId !== 1)
				ruleItems.push(
					createCategoryIdRule({
						id: searchId,
						type: CategoryType.ONLY_RECURSIVE,
					}),
				);
		}

		dispatcher.trigger('asset:gallery:show', {
			conditions: convertToRules(...ruleItems),
			page: parseInt(page) || 1,
		});
	});

	dispatcher.on(SEARCH_VISUAL_EVENT.COLOR, (color: string, page = '1') => {
		const ruleItems: SearchRule[] = [
			createVisualRule({
				type: VisualType.COLOR,
				color,
			}),
		];

		if (isBrandPortal()) {
			const searchId = getCurrentPortalProp('category');
			if (searchId && searchId !== 1)
				ruleItems.push(
					createCategoryIdRule({
						id: searchId,
						type: CategoryType.ONLY_RECURSIVE,
					}),
				);
		}

		dispatcher.trigger('asset:gallery:show', {
			conditions: convertToRules(...ruleItems),
			page: parseInt(page) || 1,
		});
	});

	dispatcher.trigger(`${SEARCH_VISUAL_BASE_EVENT}:extend`);
	dispatcher.trigger(`${SEARCH_VISUAL_BASE_EVENT}:initialized`);
});

export default {
	initialize() {
		return new Promise<typeof routes>((resolve) => {
			dispatcher.once(`${SEARCH_VISUAL_BASE_EVENT}:initialized`, () =>
				resolve(routes),
			);
			dispatcher.trigger(`${SEARCH_VISUAL_BASE_EVENT}:init`);
		});
	},
};
